import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card } from './ui/card';
import { AlertTriangle, TrendingDown, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 });

export const OptionAlertsCard = () => {
  const [alerts, setAlerts] = useState([]);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/analytics/branch/option-alerts`).then((r) => setAlerts(r.data.alerts || [])).catch(() => setAlerts([]));
  }, []);

  if (hidden || alerts.length === 0) return null;
  return (
    <Card className="p-4 border-red-200 bg-red-50/60 shadow-sm" data-testid="option-alerts-card">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-red-100 flex items-center justify-center shrink-0">
          <AlertTriangle className="h-5 w-5 text-red-600" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-black text-red-700">تنبيه: أصناف متراجعة أكثر من 30%</p>
            <button type="button" onClick={() => setHidden(true)} className="text-red-400 hover:text-red-700 transition-colors" data-testid="option-alerts-dismiss">
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="text-[11px] text-foreground/55 mb-2">مقارنة هذا الشهر حتى اليوم بنفس عدد الأيام في الفترة السابقة</p>
          <div className="space-y-1.5">
            {alerts.slice(0, 5).map((a) => (
              <div key={`${a.product_name}-${a.label}`} className="flex items-center gap-2 text-xs bg-white rounded-md px-2 py-1.5 border border-red-100" data-testid={`option-alert-${a.label}`}>
                <TrendingDown className="h-3.5 w-3.5 text-red-600 shrink-0" />
                <span className="font-bold truncate">{a.label}</span>
                <span className="text-foreground/50 truncate hidden sm:inline">({a.product_name})</span>
                <span className="mr-auto font-numbers text-foreground/60 whitespace-nowrap">{fmt(a.previous_total)} ← {fmt(a.current_total)}</span>
                <span className="font-numbers font-black text-red-600 whitespace-nowrap" dir="ltr">-{a.drop_pct}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};
